import { colors, typography } from "deprecated-theme"
import React from "react"

/**
 * All text will start off looking like this.
 */
const BASE: React.CSSProperties = {
  fontFamily: typography.primary,
  color: colors.textDark,
  fontSize: 16,
  lineHeight: "20px",
}

/**
 * All the variations of text styling within the app.
 *
 * You want to customize these to whatever you need in your app.
 */
export const presets = {
  /**
   * The default text styles.
   */
  default: BASE,

  titleMediumPrimary: {
    ...BASE,
    fontSize: 36,
    lineHeight: "42px",
    color: colors.textMuted,
  },

  /**
   * Small title (24px)
   */
  titleSmallPrimary: {
    ...BASE,
    fontSize: 24,
    lineHeight: "29px",
    color: colors.textDark,
  },

  titleSmallSecondary: {
    ...BASE,
    fontSize: 24,
    lineHeight: "29px",
    color: colors.textMuted,
  },

  bodyLargePrimary: {
    ...BASE,
    fontFamily: typography.primary,

    fontSize: 18,
    lineHeight: "30px",
  } as React.CSSProperties,

  bodyMediumPrimary: {
    ...BASE,
    fontSize: 16,
    lineHeight: "24px",
    fontFamily: typography.primary,
  } as React.CSSProperties,

  bodySmallPrimary: { ...BASE, fontSize: 14, lineHeight: "20px" } as React.CSSProperties,
  bodyLargePrimaryStrong: {
    ...BASE,
    fontSize: 18,
    lineHeight: "30px",
    fontWeight: 700,
  } as React.CSSProperties,

  /**
   * Link (Clickable)
   */
  link: {
    ...BASE,
    fontFamily: typography.primary,
    letterSpacing: 0.2,
    color: colors.textMuted,
  } as React.CSSProperties,

  actionLink: {
    ...BASE,
    fontFamily: typography.primary,
    letterSpacing: 0.2,
    color: colors.action,
  } as React.CSSProperties,

  /**
   * Field labels that appear on forms above the inputs.
   */
  fieldLabel: { ...BASE, fontSize: 16, color: colors.line, fontWeight: 700 } as React.CSSProperties,

  /**
   * Error text for a field.
   */
  fieldError: {
    ...BASE,
    fontSize: 12,
    color: colors.error,
    lineHeight: "15px",
  } as React.CSSProperties,

  /**
   * A smaller piece of secondard information.
   */
  secondary: { ...BASE, fontSize: 9, color: colors.textMuted } as React.CSSProperties,
}

/**
 * A list of preset names.
 */
export type TextPresets = keyof typeof presets
